// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bunnelby: PokeData = {
  "id": 659,
  "name": "bunnelby",
  "height": 4,
  "weight": 50,
  "base_experience": 47,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "double-slap",
    "swords-dance",
    "double-kick",
    "tackle",
    "take-down",
    "leer",
    "earthquake",
    "dig",
    "agility",
    "quick-attack",
    "super-fang",
    "flail",
    "mud-slap",
    "facade",
    "odor-sleuth",
    "bounce",
    "mud-shot",
    "bulldoze",
    "laser-focus"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "leer",
    "earthquake",
    "quick-attack",
    "mud-slap",
    "mud-shot",
    "purification",
    "headbutt",
    "protect",
    "tri-attack",
    "scratch",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 340,
    "item": null,
    "species": [
      {
        "name": "bunnelby",
        "order": 660,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "diggersby",
        "order": 661,
        "types": [
          PokeType.NORMAL,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 659,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 37.5,
    "speed": 57,
    "ability_power": 36
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
